import { darkScrollbar, Theme } from "@mui/material";
import { colors } from "./colors";
import theme from "./default";

export const darkTheme: Theme = {
  ...theme,
  palette: {
    ...theme.palette,
    mode: "dark"
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          ...darkScrollbar(),
          color: "white",
          backgroundColor: colors.yellow
        }
      }
    }
  }
};
